import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CompanyInterface } from '@app/interface/company';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { CompanyApi } from '@app/services/company-api';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { NgForm } from '@angular/forms';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  catchError,
} from 'rxjs/operators';
import { EventEmitter, Input, Output } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-company-autocomplete',
  templateUrl: './company-autocomplete.html',
  styleUrl: './company-autocomplete.scss',
  imports: [
    MatTableModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatIconModule,
  ],
  standalone: true,
})
export class CompanyAutocompleteComponent {
  @Input() myControl!: FormControl;
  @Input() filteredOptions!: Observable<string[]>;
  @Output() optionSelected = new EventEmitter<CompanyInterface | null>(); // Allow null

  // myControl = new FormControl('');
  // companyNames: string[] = []; // Array to store company names
  // filteredOptions!: Observable<string[]>;

  // companySource = new MatTableDataSource<CompanyInterface>([]);

  allCompanies: CompanyInterface[] = []; // Stores all loaded companies
  companyNames: string[] = []; // Array to store company names for filtering
  isLoading: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private companyService: CompanyApi,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.loadAllCompanies();
    this.initializeAutocomplete();
  }

  private loadAllCompanies(selectAfter?: CompanyInterface): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // Prepare filter params
    const filterParams: any = {};
    filterParams.is_deleted = false; // hide deleted invoices

    this.isLoading = true;

    this.companyService
      .getAllCompanies<CompanyInterface>(organization_id, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<CompanyInterface>) => {
          if (response.completed) {
            // All companies loaded across all pages
            this.allCompanies = response.results;
            this.companyNames = this.allCompanies.map(
              (company) => company.company_name,
            );

            // Pre-select a company if requested (e.g. after creating a new one)
            if (selectAfter) {
              this.myControl.setValue(selectAfter.company_name);
              this.optionSelected.emit(selectAfter);
            }
          }
          this.isLoading = false;
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error loading companies:', err);
          this.showErrorMessage('Errore nel caricamento dei clienti');
        },
      });
  }

  /** Ricarica la lista delle aziende. Se viene passata una company, la pre-seleziona al termine. */
  public reload(selectAfter?: CompanyInterface): void {
    this.loadAllCompanies(selectAfter);
  }

  private initializeAutocomplete(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      map((value: string) => this._filter(value || '')),
    );
  }

  private _filter(value: string): string[] {
    if (!value || value.length < 1) {
      return this.companyNames; // Return all companies when empty
    }

    const filterValue = value.toLowerCase();
    return this.companyNames.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  onOptionSelected(event: MatOptionSelectionChange, companyName: string): void {
    if (event.isUserInput) {
      const selectedCompany = this.allCompanies.find(
        (c) => c.company_name === companyName,
      );

      if (selectedCompany) {
        this.optionSelected.emit(selectedCompany);
      } else {
        console.warn('Company not found:', companyName);
        this.optionSelected.emit(null);
      }
    }
  }

  clearSelection(): void {
    this.myControl.setValue('');
    this.optionSelected.emit(null);
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  // ngOnInit() {
  //   this.loadCompanies();

  //   this.filteredOptions = this.myControl.valueChanges.pipe(
  //     debounceTime(300), // wait for the user to stop typing
  //     distinctUntilChanged(), // only emit if the value changed
  //     switchMap((value: any) => this._filter(value || '')) // switch to new observable
  //   );
  // }

  // private loadCompanies() {
  //   this.companyService.getCompanyList().subscribe({
  //     next: (companies: PaginatedResponse<CompanyInterface>) => {
  //       // this.companySource.data = companies.results;

  //       // Extract company names from the response
  //       this.companyNames = companies.results.map(
  //         (company) => company.company_name
  //       );
  //       console.log('loaded companies');
  //     },
  //     error: (err: any) => {
  //       console.error('Error loading companies:', err);
  //       this.showErrorMessage('Failed to load companies');
  //     },
  //   });
  // }

  // private _filter(value: string): Observable<string[]> {
  //   const filterValue = value.toLowerCase();
  //   const filtered = this.companyNames.filter((option) =>
  //     option.toLowerCase().includes(filterValue)
  //   );
  //   return of(filtered);
  // }

  // private showErrorMessage(message: string): void {
  //   this.snackBar.open(message, 'Close', {
  //     duration: 3000,
  //     panelClass: ['error-snackbar'],
  //     horizontalPosition: 'center',
  //     verticalPosition: 'top',
  //   });
  // }
}
